<div *gqLet="username$ | async as username" class="container">
  <a *ngIf="!username" [routerLink]="['login']">Login</a>
  <ng-container *ngIf="username">
    <a [routerLink]="['queue', username]">My Queue</a>
  </ng-container>
</div>


<router-outlet></router-outlet>
